<template>
  <span class="text-primary bg-light-cyan--bg rounded-md p-1 mr-2 text-center hover:bg-primary hover:text-white cursor-pointer">
    <slot ref="tagTextContent"></slot> 
  </span>
</template>

<script>
export default {

}
</script>

<style>

</style>